
import React from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { useState } from "react";
import LoginImage from "../Images/side-img.webp";
/* Commenting the following code for smarterresume.ray using AI Agent. 22/07/2026. Comment Start */
// import DarkLogo from "../Images/logo-blue-removebg-preview.webp";
/* Commenting end. ray using AI Agent. 22/07/2026 */
/* Added the following code for smarterresume.ray using AI Agent. 22/07/2026. Code Start */
/* Commenting the following code for logo.ray using AI Agent. 18/08/2026. Comment Start */
// import DarkLogo from "../Pages/website/images/Logo.png";
/* Commenting end. ray using AI Agent. 18/08/2026 */
/* Added the following code for logo.ray using AI Agent. 18/08/2026. Code Start */
/* Navy/blue logo for light backgrounds; white Logo.png stays on dark chrome. */
/* Commenting the following code for logo.ray using AI Agent. 24/08/2026. Comment Start */
// import DarkLogo from "../Pages/website/images/Logo-dark.svg";
/* Commenting end. ray using AI Agent. 24/08/2026 */
/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */
import DarkLogo from "../Pages/website/images/Logo-dark.png";
/* Code end. ray using AI Agent. 24/08/2026 */
/* Code end. ray using AI Agent. 18/08/2026 */
/* Code end. ray using AI Agent. 22/07/2026 */
import axios from 'axios';
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { toast } from 'react-hot-toast';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { BASE_URL } from "../config";
/* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
import { resolveTenantBranding } from "../tenantApi";
/* Code end. ray using AI Agent. Oct 9, 2026 */

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let [loading, setLoading] = useState(false);
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [open, setOpen] = useState(false);
  /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
  const [tenantBranding, setTenantBranding] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const slug = params.get("tenant") || params.get("slug");
    const host = window.location.hostname;
    const isSubdomain =
      host && !["localhost", "127.0.0.1", "dev.selftrainai.com", "selftrainai.com"].includes(host);
    if (slug || isSubdomain) {
      resolveTenantBranding({
        slug: slug || undefined,
        host: isSubdomain ? host : undefined,
      })
        .then(({ status, body }) => {
          if (status === 200 && body?.success && body.data) {
            setTenantBranding(body.data);
          }
        })
        .catch(() => {});
    }
  }, [location.search]);
  /* Code end. ray using AI Agent. Oct 9, 2026 */

  // spinner
  const load = () => {
    return (
      <div className={`flex justify-center items-center h-screen ${loading ? 'block' : 'hidden'}`}>
        <div className="bg-white p-5 rounded-lg">
          <BeatLoader loading={loading} className="text-cyan-900 text-3xl" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  };

  const toggle = () => setOpen(!open);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Fill all details");
      return;
    }
    setLoading(true);

    try {
      const payload = {
        email: String(email).trim(),
        password,
      };
      if (tenantBranding?.slug) {
        payload.tenantSlug = tenantBranding.slug;
      }
      const response = await axios.post(BASE_URL + "/api/user/login", payload);

      if (response.status === 200) {
        const { message, firstname } = response.data;
        toast.success(`${message}. Welcome, ${firstname}!`);
        localStorage.setItem("firstname", firstname);
        localStorage.setItem("token", response.data.accessToken);
        localStorage.setItem("taskid", response.data.uniqueObjid || "");
        localStorage.setItem("isAdmin", response.data.isAdmin);
        /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
        if (response.data.tenant) {
          localStorage.setItem("tenant", JSON.stringify(response.data.tenant));
        } else {
          localStorage.removeItem("tenant");
        }
        localStorage.setItem("isPlatformAdmin", String(response.data.isPlatformAdmin === true));
        localStorage.setItem("isTenantAdmin", String(response.data.isTenantAdmin === true));
        localStorage.removeItem("selftrainai:custom-capstone-project");
        localStorage.removeItem("selftrainai:custom-capstone-project:guest");
        /* Code end. ray using AI Agent. Oct 9, 2026 */
        /* Added the following code for student_capstone_isolation.ray using AI Agent. 17/10/2026. Code Start */
        // Clear all session storage modes so new user does not inherit preview or viewAs from previous session
        try {
          sessionStorage.removeItem("selftrainai_learner_preview");
          sessionStorage.removeItem("selftrainai_progress_view_as");
          sessionStorage.removeItem("selftrainai_admin_restore");
          sessionStorage.removeItem("selftrainai_act_as_tenant");
        } catch {
          /* ignore */
        }
        // Purge any alien capstone project data in localStorage from previous user/guest/preview sessions
        try {
          const activeUid = String(response.data.uniqueObjid || "").trim();
          for (let i = localStorage.length - 1; i >= 0; i--) {
            const k = localStorage.key(i);
            if (k && (k.startsWith("selftrainai:custom-capstone-project") || k.startsWith("selftrainai:capstone-"))) {
              if (!activeUid || !k.endsWith(`:${activeUid}`)) {
                localStorage.removeItem(k);
              }
            }
          }
        } catch {
          /* ignore */
        }
        /* Code end. ray using AI Agent. 17/10/2026 */
        window.dispatchEvent(new Event("auth-login"));
        navigate("/home");
      }
    } catch (err) {
      console.error("Login attempt failed:", err);
      const errMsg =
        err?.response?.data?.message ||
        (err?.response?.status === 401 ? "Invalid Credentials" : null) ||
        (err?.response?.status === 404 ? "User Not Found" : null) ||
        err?.message ||
        "Login failed. Please check your credentials.";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading ? load() : (
        <div className="flex flex-col lg:flex-row">
          <div className="hidden lg:block lg:w-1/2">
  <img src={LoginImage} className="h-screen w-full object-cover" alt="" />
</div>

          <div className="w-full lg:w-1/2">
            <form onSubmit={handleSubmit}>
              <div className="flex items-center justify-center lg:h-screen px-4 py-10">
                <div className="w-full max-w-md shadow-lg shadow-gray-700 px-6 sm:px-10 py-10 bg-gray-200 rounded-md">
                  <div className="flex flex-col items-center text-center">
                    {/* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */}
                    <div className="mb-3 inline-flex flex-col items-center">
                      {tenantBranding?.branding?.logoUrl ? (
                        <img
                          src={tenantBranding.branding.logoUrl}
                          alt={tenantBranding.name}
                          className="mb-2 block h-12 w-auto max-w-[220px] object-contain"
                        />
                      ) : (
                        <img src={DarkLogo} alt="SelfTrainAI logo" className="block h-auto w-0 min-w-full object-contain" />
                      )}
                      <p className="mt-1 whitespace-nowrap text-sm tracking-wide text-[#044661]">
                        {tenantBranding ? (tenantBranding.branding?.title || tenantBranding.name) : "From Learning AI to Building AI"}
                      </p>
                    </div>
                    <h2 className="text-2xl font-semibold text-gray-600">
                      {tenantBranding ? `Welcome to ${tenantBranding.name}` : "Welcome to SelfTrainAI"}
                    </h2>
                    <p className="text-lg text-gray-500 font-semibold">Please Sign-In to your account and start</p>
                    {/* Code end. ray using AI Agent. Oct 9, 2026 */}
                  </div>

                  <div className="mt-6 space-y-4">
                    <div>
                      <label className="block text-gray-500 font-semibold mb-1">Email</label>
                      <input
                        type="email"
                        value={email}
                        className="w-full border p-2 rounded"
                        onChange={(e) => setemail(e.target.value)}
                      />
                    </div>

                    <div className="relative">
                      <label className="block text-gray-500 font-semibold mb-1">Password</label>
                      <input
                        type={open ? "text" : "password"}
                        value={password}
                        className="w-full border p-2 rounded"
                        onChange={(e) => setpassword(e.target.value)}
                      />
                      <div className="absolute bottom-2 right-3 text-2xl text-gray-400 cursor-pointer">
                        {open ? <FaEyeSlash onClick={toggle} /> : <FaEye onClick={toggle} />}
                      </div>
                    </div>

                    <div className="text-right">
                      <Link to={"/forgetpassword"} className="text-sky-800 font-semibold text-sm">
                        Forgot Password?
                      </Link>
                    </div>

                    <div>
                      <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded w-full"
                      >
                        Login
                      </button>
                    </div>

                    <div className="text-center">
                      <span className="text-gray-500 font-semibold">Don't have an Account? </span>
                      <Link className="font-semibold text-sky-800" to={tenantBranding?.slug ? `/register?tenant=${tenantBranding.slug}` : "/register"}>Sign Up</Link>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;